import * as React from "react";
const SvgIcPlus = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8.75 2.5H11.25V8.75H17.5V11.25H11.25V17.5H8.75V11.25H2.5V8.75H8.75V2.5Z" fill="currentColor" /></svg>;
export default SvgIcPlus;